import { Stack, StackProps, styled, Typography } from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import { generateNamesObject } from '../../utils';

export const stackItemClasses = generateNamesObject(['title', 'name', 'value', 'root', 'secondaryText'], 'StackItem');

const StackItemContainer = styled(Stack)(({ theme }) => ({
    gap: theme.spacing(1),
    [`& .${stackItemClasses.title}`]: {
        fontSize: 13,
        color: theme.palette.text.secondary,
    },
    [`& .${stackItemClasses.name}`]: {
        fontSize: 14,
        fontWeight: 500,
    },
    [`& .${stackItemClasses.value}`]: {
        fontSize: 14,
    },
    [`& .${stackItemClasses.secondaryText}`]: {
        fontSize: '12px',
        color: theme.palette.text.secondary,
    },
}));

export type StackItemProps = {
    title?: string;
    name?: string;
    value?: React.ReactNode;
    secondary?: boolean;
};

export const StackItem: React.FunctionComponent<StackItemProps & StackProps> = ({
    title = '',
    name = '',
    value = null,
    secondary = false,
    ...rest
}) => {
    return (
        <StackItemContainer {...rest} className={clsx(stackItemClasses.root, rest.className)}>
            {title && <Typography className={stackItemClasses.title}>{title}</Typography>}
            {name && (
                <Typography className={clsx(stackItemClasses.name, { [stackItemClasses.secondaryText]: secondary })}>
                    {name}
                </Typography>
            )}
            {value && (
                <Typography className={clsx(stackItemClasses.value, { [stackItemClasses.secondaryText]: secondary })}>
                    {value}
                </Typography>
            )}
            {rest.children}
        </StackItemContainer>
    );
};
